import { prop } from "fw";

export class UserInfo {
    @prop(null) field;
    @prop(null) label;
}
